import React, {useEffect, useState, createRef} from 'react';
import ReactWordcloud from 'react-wordcloud';
import {select} from 'd3-selection';
import "d3-transition";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/scale.css";
import { saveSvgAsPng } from 'save-svg-as-png';
import DropdownEditRelation from '../../../container/dropdown/dropdown-relation/DropdownEditRelation';

import 'tippy.js/themes/light-border.css';

const WordCloud = (props) => {
  const [words, setWords] = useState(props.data);
  const wordCloudRef = createRef();

  useEffect(() => {
    setWords(props.data)
  }, [props.data])

  const handleSave = () => {
    const svgElement = wordCloudRef.current.querySelector('svg');
    let today = new Date();
    const name = `${props.reportName}_${today.toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"}).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}`;

    saveSvgAsPng(svgElement, name);
  }

  const handleWords = (wordList) => {
    setWords(wordList);
  }

  const getCallback = (callback) => {
    return (word, event) => {
      const isActive = callback !== "onWordMouseOut";
      const element = event.target;
      const text = select(element);
      text
        // .on("click", () => {
        //   if (isActive) {
        //   }
        // })
        .transition()
        // .attr("background", "white")
        // .attr("font-size", isActive ? "300%" : "100%")
        .attr("text-decoration", isActive ? "underline" : "none");
    }
  }

  const callbacks = {
    // getWordColor: (word) => (word.value > 50 ? "orange" : "purple"),
    getWordTooltip: (word) =>`${word.text} (${word.value})`,
    // onWordClick: getCallback("onWordClick"),
    onWordMouseOut: getCallback("onWordMouseOut"),
    onWordMouseOver: getCallback("onWordMouseOver")
  }

  const options = {
    // fontFamily: "impact",
    // fontSizes: [15, 50],
    // fontStyle: "normal",
    // fontWeight: "normal",
    // padding: 1,
    // rotations: 2,
    // rotationAngles: [0, 30],
    // scale: "sqrt",
    // spiral: "archimedean",
    // transitionDuration: 1000,
    // tooltipOptions: {
    //   theme: 'light-border'
    // }
    // // enableTooltip: false
    colors: [  "#6E37FA", "#32BBB9", "#FF9408", "#F40953", "#FA32A0", "#B30095", "#FFD500", "#AAF564", "#50E6AA", "#2765F0"    ],
    fontFamily: "impact",
    fontSizes: [15, 50],
    fontStyle: "normal",
    fontWeight: "normal",
    padding: 1,
    rotations: 3,
    rotationAngles: [0, 90],
    scale: "sqrt",
    spiral: "rectangular",
    transitionDuration: 1000,
    deterministic: false,
    tooltipOptions: {
      theme: 'light-border'
    },
    enableTooltip: true
  };

  return (
    <>
      {/* <div style={{display: "flex", float: "right"}}> */}
      <div style={{textAlign:"right", marginRight:"10px"}}>
        {/* <a className="button purple_line" style={{margin: "10px 10px 0px 0px"}} onClick={handleSave}>Save</a>&nbsp; */}
        <a className="button purple_line" onClick={handleSave}>Save</a>&nbsp;
        {/* <DropdownEditRelation words={words} handleWords={handleWords} /> */}
        <DropdownEditRelation words={words} handleWords={handleWords} toggle="edit" />
      </div>
      <span ref={wordCloudRef}>
        <ReactWordcloud maxWords={props.maxWords} words={words} options={options} callbacks={callbacks} size={[props.width, props.height]}/>
      </span>
    </>
  )
}

export default WordCloud;